import { getStorageLocations } from '@/api/storageLocations'

function unwrapList(res) {
  if (Array.isArray(res?.data)) return res.data
  if (Array.isArray(res?.items)) return res.items
  if (Array.isArray(res)) return res
  return []
}

/**
 * 分页拉齐库位列表（避免单次 per_page 上限漏项）。
 * @param {object} [extraParams] 额外查询参数，如 { is_active: true }
 */
export async function fetchAllStorageLocations(extraParams = {}) {
  const pageSize = 500
  const all = []
  let page = 1
  let total = null
  while (page <= 40) {
    const res = await getStorageLocations({
      page,
      per_page: pageSize,
      ...extraParams
    })
    const list = unwrapList(res)
    all.push(...list)
    total = res?.pagination?.total ?? res?.total ?? null
    if (!list.length) break
    if (total != null && all.length >= Number(total)) break
    if (list.length < pageSize) break
    page += 1
  }
  const seen = new Set()
  const deduped = []
  for (const loc of all) {
    const id = loc?.location_id
    if (id == null || seen.has(id)) continue
    seen.add(id)
    deduped.push(loc)
  }
  deduped.sort((a, b) =>
    String(a.location_code || '').localeCompare(String(b.location_code || ''), 'zh')
  )
  return deduped
}

/** 全部启用库位（移库 / 期初入库等选库位） */
export async function fetchAllActiveStorageLocations() {
  return fetchAllStorageLocations({ is_active: true })
}
